import TextField from '@material-ui/core/TextField'
import React from 'react'
import { connect } from 'react-redux'
import ButtonAddInfo from '../../components/controls/ButtonAddInfo'
import ExpandableListElement from '../../components/controls/ExpandableListElement'
import Szambelan from '../../components/Szambelan'
import { controlHasError } from '../../lib/errorHandler'
import * as actions from '../../store/actions'
import MainStyle from '../../styles/MainStyle'
import { formatDate, dateFromCalendar } from '../../lib/formatDateHandler'
import WykazJednostekSkonsolidowaneStyle from '../../styles/WykazJednostekSkonsolidowaneStyle'
import CustomDatePicker from '../../components/controls/CustomDatePicker'
import logo from '../../assets/images/szambelan_czas_trwania.svg'

function WykazCzasuTrwania({ onSetSectionDataArray, section, validityErrors }) {
  const struktura = {
    Nazwa: '',
    DataOd: '',
    DataDo: '',
    DataDoOpis: '',
  }
  return (
    <MainStyle
      className={section.Dane.Pozycje.length > 0 ? '' : 'hide-on-print'}
    >
      <WykazJednostekSkonsolidowaneStyle>
        <div className="site-header high-emphasis-subtitle-1">
          <span>WYKAZ CZASU TRWANIA JEDNOSTEK POWIĄZANYCH</span>
          <ButtonAddInfo label="DODAJ JEDNOSTKĘ" structure={struktura} />
        </div>
        {section.Dane.Pozycje.length > 0 ? (
          <div className="container">
            <div className="list-header caption">
              <p>NAZWA I SIEDZIBA JEDNOSTKI POWIĄZANEJ</p>
            </div>
            {section.Dane.Pozycje.map((data, index) => (
              <ExpandableListElement
                placeholder="Nazwa i siedziba jednostki powiązanej"
                expandationDisabled={true}
                nazwaPozycji={data.Nazwa}
                key={index}
                index={index}
                hasError={(name, value) =>
                  controlHasError(validityErrors, name, value, true)
                }
              >
                <div className="header dates-header">
                  <p>DATA OD</p>
                  <p>DATA DO</p>
                  <p>DATA DO (OPIS)</p>
                </div>
                <div className="subsection">
                  <div className="dates">
                    <CustomDatePicker
                      name="DataOd"
                      error={controlHasError(
                        validityErrors,
                        'DataOd',
                        data.DataOd,
                      )}
                      label="Data od"
                      value={formatDate(data.DataOd)}
                      onChange={e =>
                        onSetSectionDataArray(
                          dateFromCalendar(e),
                          index,
                          'DataOd',
                        )
                      }
                    />
                    <p className="separator">-</p>
                    <CustomDatePicker
                      name="DataDo"
                      error={controlHasError(validityErrors, 'DataDo')}
                      label="Data do"
                      value={formatDate(data.DataDo)}
                      onChange={e =>
                        onSetSectionDataArray(
                          dateFromCalendar(e),
                          index,
                          'DataDo',
                        )
                      }
                    />
                    <TextField
                      error={controlHasError(validityErrors, 'DataDoOpis')}
                      name="DataDoOpis"
                      label="Data do (opis)"
                      title={data.DataDoOpis}
                      defaultValue={data.DataDoOpis}
                      onBlur={e => onSetSectionDataArray(e, index)}
                    />
                  </div>
                </div>
              </ExpandableListElement>
            ))}
          </div>
        ) : (
          <Szambelan
            logo={logo}
            text={
              <>
                Brak informacji o czasie trwania <br /> jednostek powiązanych
              </>
            }
          />
        )}
      </WykazJednostekSkonsolidowaneStyle>
    </MainStyle>
  )
}

const mapStateToProps = state => ({
  validityErrors: state.sprawozdanie.validityErrors
    ? state.sprawozdanie.validityErrors.filter(
        value => value.TypSekcji === 'WykazCzasuTrwania',
      )
    : [],
})

const mapDispatchToProps = dispatch => ({
  onSetSectionDataArray: (e, index, name) => {
    let value, targetName
    if (name) {
      value = e
      targetName = name
    } else {
      // eslint-disable-next-line prefer-destructuring
      value = e.target.value
      targetName = e.target.name
    }
    dispatch(actions.setSectionDataArray(value, index, 0, targetName))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WykazCzasuTrwania)
